import { createTheme, responsiveFontSizes } from "@mui/material";

export const theme = (direction: 'ltr' | 'rtl') => responsiveFontSizes(createTheme({
    palette: {
        primary: {
            main: '#79533a'
        },
        secondary: {
            main: '#D1B060',
            dark: '#B86F2E'
        },
    },
    components: {
        MuiCircularProgress: {
            defaultProps: {
                size: 12
            }
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    direction: direction,
                    '.MuiButton-startIcon': {
                        // marginRight: direction == 'rtl' ? '8px' : undefined,
                        marginLeft: direction === 'rtl' ? '8px' : undefined
                    },
                    '.MuiButton-endIcon': {
                        marginRight: direction === 'rtl' ? '8px' : undefined,
                        // marginLeft: direction == 'rtl' ? '8px' : undefined
                    },
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    "& .MuiTab-root": {
                        marginRight: 5,
                        "&:last-child": {
                            marginRight: direction === 'ltr' ? 0 : undefined,
                            marginLeft: direction === 'rtl' ? 0 : undefined,
                        },
                    },
                },
                indicator: {
                    display: 'none'
                },
            }
        },
        MuiTab: {
            styleOverrides: {
                root: ({ theme }) => ({
                    border: `2px solid ${theme.palette.primary.main}`,
                    color: theme.palette.primary.main,
                    fontWeight: 'bold',
                    borderRadius: 10,
                    "&.Mui-selected": {
                        "backgroundColor": theme.palette.primary.main,
                        "color": "white"
                    }
                }),
            }
        },
        MuiGrid2: {
            styleOverrides: {
                root: {
                    direction
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    direction
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    textAlign: direction === 'rtl' ? 'right' : 'left',
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    direction: direction,
                    textAlign: direction === 'rtl' ? 'right' : 'left',
                    right: direction === 'rtl' ? 27 : undefined,
                    left: direction === 'rtl' ? 'unset' : undefined,
                    transformOrigin: direction === 'rtl' ? 'top right' : undefined,
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    direction: direction
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    textAlign: direction === 'rtl' ? 'right' : 'left'
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    direction: direction
                }
            }
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    '.MuiSvgIcon-root': {
                        marginLeft: direction === 'rtl' ? 10 : undefined
                    }
                },
            }
        },
    }
}));